/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { publicApiNames } from "publicApis/constants";

export const isNonEmptyString = value => value && typeof value === "string";

export const isString = value => typeof value === "string";

export const isBoolean = value => typeof value === "boolean";

export const isUndefined = value => typeof value === "undefined";

export const isNumber = value => !isNaN(value) && typeof value === "number";

export const isFunction = value => value && typeof value === "function";

export const isHexColor = value => {
  const isOk = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(value);
  return isOk;
};

export const isObject = value => typeof value === "object";

const noValidator = value => true;

const validProperties = {
  visible: isBoolean,
  color: isHexColor,
  disable: isBoolean,
  notificationMsg: isNonEmptyString,
  notificationOpts: isObject,
  disabledTooltipStr: isString
};

export const setComponentProperty = (map, componentName, property, value) => {
  const config = map.get(componentName);
  if (config && config.hasOwnProperty(property)) {
    const isValid = validProperties[property] || noValidator;
    if (isValid(value)) {
      config[property] = value;
      map.set(componentName, config);
    }
  }
};

export const updateComponentProperties = (map, componentName, config) => {
  if (map.has(componentName)) {
    for (let property in validProperties) {
      if (config.hasOwnProperty(property)) {
        setComponentProperty(map, componentName, property, config[property]);
      }
    }
  }
};

// List only the public APIs which we want to expose
export const allApisList = [
  publicApiNames.APP,
  publicApiNames.DOCUMENT,
  publicApiNames.HUD,
  publicApiNames.LHP,
  publicApiNames.RHP,
  publicApiNames.QUICKTOOLS,
  publicApiNames.STICKYTOOLS,
  publicApiNames.LIQUIDMODE,
  publicApiNames.NAVIGATIONBAR,
  publicApiNames.FTE,
  publicApiNames.BOTTOM_BOARD,
  publicApiNames.FAB,
  publicApiNames.TOP_PANEL,
  publicApiNames.FLOATING_WINDOWS
];
